import mapParcelOrgBase from '@pperform/pp-data-mappers/parcelOrg';
import mapCarrierOrg from '@pperform/pp-data-mappers/carrierOrg';
import PmParcel from 'interfaces/PmParcel';
import {
  LineItem,
  MixedEvent,
  Shipment,
  OrgCarrierConfig,
  ShipmentEvent,
  OrderTracking,
} from '@pperform/pp-data-mappers';
import merge from 'lodash.merge';

const mapFrontEndAdditionalData = (data) => {
  if (!data) return undefined;

  return {
    hasLineItems: data.has_line_items,
  };
};

const mapParcelOrg = (shipmentDto): PmParcel => {
  const { frontend_additional_data: frontEndAdditionalData, ...shipment } =
    shipmentDto;

  const data = {
    ...mapParcelOrgBase(shipment),
    id: shipmentDto.id,
    parcelperformId: shipmentDto.parcelperform_id,
    orderTracking: OrderTracking.fromApiData(shipment.order_tracking),
    typeOfShipment: shipment.type_of_shipment,
    frontEndAdditionalData: mapFrontEndAdditionalData(frontEndAdditionalData),
    shipmentEvents: shipment.shipment_events?.map((shipmentEvent) =>
      ShipmentEvent.fromApiData(shipmentEvent),
    ),
    mixedEvents: shipment.mixed_events?.map((mixedEvent) =>
      MixedEvent.fromApiData(mixedEvent),
    ),
    latestMixedEvent: MixedEvent.fromApiData(shipment.latest_mixed_event),
    lineItems: shipment.line_items?.map((lineItem) =>
      LineItem.fromApiData(lineItem),
    ),
    orgCarrierConfig: OrgCarrierConfig.fromApiData(shipment.org_carrier_config),
    parcelUserTag: shipment.parcel_user_tag,
    additionalData: {
      linkedShipmentTrackingNumber:
        shipment?.additional_data?.linked_shipment_tracking_number,
      linkedShipmentCarrierOrg: mapCarrierOrg(
        shipment?.additional_data?.linked_shipment_carrier_org,
      ),
    },
  };

  return merge(Shipment.fromApiData(shipment), data);
};

export function mapParcelOrgToApi<T>(shipment: PmParcel): T {
  const { parcel, ...rest } = Shipment.create(shipment, {
    partial: false,
  }).toApiData();

  return {
    ...rest,
    parcel: {
      ...parcel,
      delivered_date: parcel.delivered_date?.time ?? null,
    },
  } as T;
}

export default mapParcelOrg;
